import { render, staticRenderFns } from "./task_customer.vue?vue&type=template&id=1929cc4e&scoped=true"
import script from "./task_customer.vue?vue&type=script&lang=js"
export * from "./task_customer.vue?vue&type=script&lang=js"
import style0 from "./task_customer.vue?vue&type=style&index=0&id=1929cc4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1929cc4e",
  null
  
)

export default component.exports